/**
 * Multi-word search for service/cost pickers (Proposals, Contracts).
 *
 * The query is split on whitespace and every word must match at least one of
 * the option's searchable fields (AND across words, substring within a field),
 * so "amoor consult" finds services whose vendor contains "amoor" and whose
 * name/category contains "consult".
 */

// Extra words indexed for each normalized frequency so users can type
// "monthly", "recurring", "one time", "onetime", "once", ...
const FREQUENCY_ALIASES = {
  monthly: 'monthly month recurring',
  'one-time': 'one-time one time onetime once',
};

const normalizeText = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[_]+/g, ' ')
    .trim();

const normalizeFrequency = (raw) => {
  const f = normalizeText(raw).replace(/[\s-]+/g, '');
  if (f === 'monthly' || f === 'month') return 'monthly';
  if (f === 'onetime' || f === 'once') return 'one-time';
  return '';
};

export const frequencySearchText = (frequency) => {
  const key = normalizeFrequency(frequency);
  return [normalizeText(frequency), FREQUENCY_ALIASES[key] || ''].filter(Boolean).join(' ');
};

export const buildServiceSearchText = (fields) =>
  (fields || [])
    .filter((f) => f !== null && f !== undefined && f !== '')
    .map(normalizeText)
    .join(' | ');

export const matchesServiceQuery = (searchText, query) => {
  const words = normalizeText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  return words.every((word) => searchText.includes(word));
};

/**
 * Drop-in for MUI Autocomplete `filterOptions`.
 * @param {Array} options
 * @param {string} inputValue
 * @param {(option) => Array<string|number>} getFields searchable field values
 */
export const filterServiceOptions = (options, inputValue, getFields) =>
  (options || []).filter((option) =>
    matchesServiceQuery(buildServiceSearchText(getFields(option)), inputValue)
  );
